import React, {Component} from "react";

class CheckBox extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.value !== nextProps.value
            || this.props.label !== nextProps.label
        )
    }

    handleChange(event) {
        const { id, onChange } = this.props;
        const value = event.target.value;
        onChange(id, value);
    }

    render() {
        const { label, id, value, name} = this.props;
        const { handleChange } = this;

        return (
            <div className="d-flex align-items-center">
                <input type="checkbox" className="form-check-input m-0" id={id} name={name} value={value} checked={value === true} onChange={handleChange}/>
                <label htmlFor={id} className="ms-2">{label}</label>
            </div>
        )
    }
}

CheckBox.defaultProps = {
    id: '',
    name: '',
    label: '',
    value: '',
    onChange: function() {},
}

export default CheckBox;
